<template lang="pug">
div
  template(v-if="appointment && appointment.appointments.length")
    v-form(ref="form")
      div.text-md.neutral700--text.font-semibold Please select the appointments to record payment now
      div.text-sm.neutral500--text The unselected appointments will be considered as 'pay later'
      v-card.mt-4.round-lg(outlined)
        template(v-for="(appointment, index) in appointment.appointments")
          appointment-payment-item.pa-4(:appointment="appointment" :index="index" :key="`${appointment.id}-${index}`")
          v-divider
        v-row.pa-4(dense align="center")
          v-col(cols="8")
            div.text-xs.neutral500--text.font-semibold.text-right Total
          v-col(cols="4")
            div.text-sm.neutral700--text.font-semibold.text-right {{ $options.filters.displayPrice(totalPrice, $currency) }}

      template(v-if="totalPrice > 0")
        v-card.round-lg.neutral300.pa-4.mt-6(flat)
          div.text-sm.font-semibold {{ $t('select_payment_method') }}
          v-select.text-sm.mt-2.round-xl(v-model="payment.payment_method" :items="paymentMethods" :placeholder="$t('select_payment_method')" background-color="neutral100" outlined :rules="rules.not_empty_select ? rules.not_empty_select : []" :loading="isFetching" hide-details="auto")
          v-text-field.text-sm.mt-2.round-xl(v-model="payment.internal_description" :placeholder="$t('notes_on_payment_optional')" background-color="neutral100" outlined hide-details="auto")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppointmentPaymentItem from '@/components/clinic/appointment/advance/AppointmentPaymentItem.vue'

export default {
  components: { AppointmentPaymentItem },
  data () {
    return {
      isFetching: false,
      paymentMethods: [],
      fees: [],
      payment: {},
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointment: 'clinic/getTempAppointment',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    paymentData () {
      return {
        payment: { ...this.payment }
      }
    },
    totalPrice () {
      let total = 0
      if (this.appointment && this.appointment.appointments.length) {
        total = (this.appointment.appointments.filter(f => f.amount).map(m => m.amount).reduce((total, num) => { return total + num }, 0))
      }
      return total
    },
    leadProducts () {
      let ids = []
      if (this.appointment && this.appointment.appointments.length) {
        this.appointment.appointments.forEach(o => {
          if (o.leadproducts && o.leadproducts.length) {
            ids = [ ...ids, ...o.leadproducts]
          }
        })
      }
      return ids
    },
    companySlug () {
      return this.isHq ? this.hqSelectedCompany.slug : this.company.slug
    }
  },
  watch: {
    paymentData: {
      deep: true,
      handler (val) {
        this.$store.commit('clinic/updateTempAppointment', val)
      } 
    },
    totalPrice (val) {
      this.$set(this.payment, 'amount', val)
      this.$set(this.payment, 'leadproducts', this.leadProducts)
    }
  },
  mounted () {
    this.fetchPaymentMethods()
    this.$set(this.payment, 'amount', this.totalPrice)
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPaymentMethods () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.companySlug}/payment_methods`)
        .then(resp => {
          this.paymentMethods = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>